export default {
  $ID: 'simpleLayout2',
  Name: 'My layout 2',
  Model: {
    $ID: 'zz',
    $Type: 'dr-layout-placeholder',
    Name: 'Main'
  },
  LayoutType: ['responsive']
}
